import { db } from "../firebaseConfig";
import {
  collection, addDoc, updateDoc, deleteDoc, doc,
  getDocs, getDoc, query, where, orderBy, limit,
  serverTimestamp
} from "firebase/firestore";

export async function listActiveHomeBanners({ take = 10 } = {}) {
  const snap = await getDocs(
    query(
      collection(db, "homeBanners"),
      where("active", "==", true),
      orderBy("order", "asc"),
      limit(take)
    )
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function adminListHomeBanners() {
  const snap = await getDocs(
    query(collection(db, "homeBanners"), orderBy("order", "asc"))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function adminCreateHomeBanner(payload) {
  const ref = await addDoc(collection(db, "homeBanners"), {
    ...payload,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  const fresh = await getDoc(ref);
  return { id: fresh.id, ...fresh.data() };
}

export async function adminUpdateHomeBanner(id, payload) {
  await updateDoc(doc(db, "homeBanners", id), {
    ...payload,
    updatedAt: serverTimestamp(),
  });
}

export async function adminDeleteHomeBanner(id) {
  await deleteDoc(doc(db, "homeBanners", id));
}

/** Bannières actives par placement */
export async function listActiveHomeBannersByPlacement(placement, { take = 10 } = {}) {
  const snap = await getDocs(
    query(
      collection(db, "homeBanners"),
      where("active", "==", true),
      where("placement", "==", placement),
      orderBy("order", "asc"),
      limit(take)
    )
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
